module.exports = __webpack_public_path__ + "static/media/sadFace.2810f1c2.png";